import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { a as o } from "../internals/a-callable.js";
import { t as a } from "../internals/to-indexed-object.js";
import { a as s } from "../internals/array-from-constructor-and-list.js";
import { e as n } from "../internals/entry-virtual.js";
import { a as i } from "../internals/add-to-unscopables.js";
var e = Array,
  m = t(n("Array").sort);
r({
  target: "Array",
  proto: !0
}, {
  toSorted: function toSorted(r) {
    return void 0 !== r && o(r), m(s(e, a(this)), r);
  }
}), i("toSorted");